import { LOCATION_CHANGE } from 'connected-react-router';

import { createMiddleware } from '@shared/redux';
import { showSuccessToast, showErrorToast } from '@shared/toasts/toasts.state';
import { match } from '@shared/utils/match';
import * as AuthService from '../auth-service';
import { isSignInFromSignUp, rejectSignIn } from '../sign-in/sign-in.state';
import { ROUTES } from '../auth.constants';
import { redirectToHome } from '../auth-base-state';
import {
    acceptForgotPassword,
    FORGOT_PASSWORD_REJECTED,
    FORGOT_PASSWORD_SUBMITTED,
    rejectForgotPassword,
} from './forgot-password-state';
import { validateForgotPassword } from './forgot-password.validation';
import { FORGOT_PASSWORD_TEXTS } from './forgot-password.constants';
import { getCognitoErrorMessage } from './forgot-password.utils';

export const forgotPasswordMiddleware = createMiddleware({
    [LOCATION_CHANGE]: match((_, action) => action.payload.location.pathname, {
        [ROUTES.FORGOT_PASSWORD]: () => (
            AuthService.currentAuthenticatedUser()
                .then(() => redirectToHome())
                .catch(() => null)
        ),
    }),

    [FORGOT_PASSWORD_SUBMITTED]: async (state, action) => {
        try {
            await validateForgotPassword(action.payload);
        } catch (error) {
            return rejectForgotPassword({ code: 'YupException', error });
        }

        const toastMessage = FORGOT_PASSWORD_TEXTS.CODE_SENT_MESSAGE.replace('{email}', action.payload.username);

        try {
            const user = await AuthService.forgotPassword(action.payload);

            const errorlessSignIn = state.auth.signIn;
            Object.assign(errorlessSignIn, { error: null });

            return [
                acceptForgotPassword({ user, ...errorlessSignIn }),
                showSuccessToast({ message: toastMessage }),
            ];
        } catch (error) {
            return [
                rejectForgotPassword({ code: error.code || 'UnknownException', error }),
                showErrorToast({ message: getCognitoErrorMessage(error) }),
            ];
        }
    },
    [FORGOT_PASSWORD_REJECTED]: (state, action) => (
        rejectSignIn({
            code: action.payload.code,
            error: action.payload.error,
            fromSignUp: isSignInFromSignUp(state),
        })
    ),
});
